import { FC } from "react";
import { ProjectDetailsTab } from "../pages/UBTAdmin/ProjectDetails/projectTabs/projectDetails";
import { TestOfChangeTab } from "../pages/UBTAdmin/ProjectDetails/projectTabs/testOfChange";
import { TestDataTab } from "../pages/UBTAdmin/ProjectDetails/projectTabs/testData";
export interface TabData {
  id: number;
  title: string;
  component: FC<any>;
}

export const projectTabs: TabData[] = [
  { id: 1, title: "Project Details", component: ProjectDetailsTab },
  { id: 2, title: "Test of Change", component: TestOfChangeTab },
  { id: 3, title: "Test Data", component: TestDataTab },
];
